import { fetchData } from '../utils/fetch';
import config from '../../config';
import { Page } from '../../logic/main/types';

export const fetchPage = async ({
  title,
  path,
  include_layout,
  locale,
  viewer_country,
  viewer_region,
  logged_in,
  base_path,
  accountID,
}: {
  title: string;
  path: string;
  include_layout?: boolean;
  locale?: string;
  viewer_country?: string;
  viewer_region?: string;
  base_path?: string;
  logged_in: boolean;
  accountID?: string;
}) => {
  try {
    const res = await fetchData<{
      page?: Page;
      trackingInfo: { [key: string]: string | null };
      personalizedBanners?: { selector: string; slug?: string }[];
      properties: {
        status: 'FOUND' | 'NOT FOUND' | 'NOT_FOUND';
        segments: string[] | null;
        pageTitle?: string;
        liveDealerTables?: string[];
      };
    }>({
      url: `${config.urls.bffBaseUrl}/page`,
      queryParameters: {
        title,
        path,
        include_layout,
        locale,
        market_country: viewer_country,
        market_region: viewer_region,
        logged_in,
        base_path,
        accountID,
        new_data: true,
      },
    });

    return res;
  } catch (err) {
    console.error(
      `There was a problem while fetching page. ${config.urls.bffBaseUrl}/page`
    );
    console.error(err);

    return null;
  }
};
